import React from 'react';
import PropTypes from 'prop-types';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import Component from '@plone/volto/components/theme/Component/Component';
import { Icon } from 'semantic-ui-react';
import { FormattedDate } from 'react-intl';
import config from '@plone/volto/registry';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

const GridTemplate = ({ items, linkTitle, linkHref, isEditMode, data = {} }) => {
  let link = null;
  const href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  const ctaLabel = data?.ctaLabel || data?.buttonLabel || 'Read more';

  return (
    <>
      <div className="items">
        {items.map((item) => {
          const itemUrl = flattenToAppURL(item['@id']);
          const description = item.description || item.Description;

          const dateValue =
            item.created ||
            item.CreationDate ||
            item.effective ||
            item.EffectiveDate ||
            item.start ||
            null;

          const ItemBodyTemplate = () => {
            const hasType = item['@type'];
            const CustomItemBodyTemplate = config.getComponent({
              name: 'GridListingItemTemplate',
              dependencies: [hasType],
            }).component;

            return CustomItemBodyTemplate ? (
              <CustomItemBodyTemplate item={item} />
            ) : (
              <div className="card-container">
                {item.image_field !== '' && (
                  <Component
                    componentName="PreviewImage"
                    item={item}
                    alt=""
                    className="item-image"
                  />
                )}
                <div className="item">
                  <div className="content">
                    {dateValue && (
                      <div className="listingItem__date">
                        <FormattedDate
                          value={new Date(dateValue)}
                          year="numeric"
                          month="long"
                          day="2-digit"
                        />
                      </div>
                    )}

                    <h2>{item?.title}</h2>
                    {!item.hide_description && <p>{description}</p>}
                  </div>
                </div>

                <div className="listingItem__actions">
                  <UniversalLink
                    href={itemUrl}
                    className="ui button listingItem__cta"
                  >
                    <Icon name="caret right" />
                    {ctaLabel}
                  </UniversalLink>
                </div>
              </div>
            );
          };

          return (
            <div className="listing-item" key={item['@id']}>
              <ItemBodyTemplate item={item} />
            </div>
          );
        })}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

GridTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkTitle: PropTypes.any,
  linkHref: PropTypes.any,
  isEditMode: PropTypes.bool,
  data: PropTypes.object,
};

export default GridTemplate;
